import { render, staticRenderFns } from "./DoctorProfileDetail.vue?vue&type=template&id=74688362&"
import script from "./DoctorProfileDetail.vue?vue&type=script&lang=js&"
export * from "./DoctorProfileDetail.vue?vue&type=script&lang=js&"
import style0 from "./DoctorProfileDetail.vue?vue&type=style&index=0&id=74688362&prod&lang=scss&"
import style1 from "./DoctorProfileDetail.vue?vue&type=style&index=1&id=74688362&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports